/**
 * Created by lu on 2017/12/11.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        tag: 'li',
        'class': 'img-item',
        $html: [{
            tag: 'a',
            'data-uk-lightbox': 'data-uk-lightbox',
            'data-lightbox-type': 'image',
            href: nb.bind('_src'),
            $html: {
                tag: 'img',
                'class': 'image',
                src: nb.bind('src')
            }
        }, {
            'class': 'delete',
            $html: {
                'class': 'iconfont icon-cha',
                style: {
                    'color': '#d81e06',
                    'cursor': 'pointer'
                }
            }
        }],
        style: {
            'width': nb.bind('imgWitch'),
            'height': nb.bind('imgHeight')
        }
    },
    method: {
        init: function () {
            var self = this;


        },
        onModelReady: function (inModel) {
            inModel.onChange('src', function (inEvent, inSrc) {
                if (inSrc)
                    inModel.set('_src', inSrc.replace('?x-oss-process=image/circle,r_1000', ''));
            }, this, {before: true});

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/uploadImg/ImgItem.js
// module id = 88
// module chunks = 3 4 8 19 29